import { render, staticRenderFns } from "./Mind.vue?vue&type=template&id=fdb075d8&"
import script from "./Mind.vue?vue&type=script&lang=js&"
export * from "./Mind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports